import { Stack } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import {
  useFonts,
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
  Inter_700Bold,
  Inter_800ExtraBold,
} from '@expo-google-fonts/inter';
import { AuthProvider } from '../src/context/AuthContext';
import { ThemeProvider, useThemeMode } from '../src/context/ThemeContext';
import { ErrorBoundary } from '../src/components/ErrorBoundary';
import { colors } from '../src/theme';

function NavigationRoot() {
  const { mode } = useThemeMode();
  // Remounting (via `key`) instead of relying on re-render propagation is
  // deliberate: colors/gradients in theme.ts are mutated in place rather
  // than passed down as props, so every already-mounted screen needs a
  // fresh mount to actually pick up the new palette.
  return (
    <>
      <StatusBar style={mode === 'dark' ? 'light' : 'dark'} />
      <Stack key={mode} screenOptions={{ headerShown: false, contentStyle: { backgroundColor: colors.background } }} />
    </>
  );
}

export default function RootLayout() {
  // Never gate the whole app behind font loading — if this hook errors or
  // hangs (e.g. a slow/blocked font request), the app must still render
  // with the system font rather than stay on a blank screen forever. Once
  // loaded, React re-renders with the new fonts automatically.
  useFonts({
    Inter_400Regular,
    Inter_500Medium,
    Inter_600SemiBold,
    Inter_700Bold,
    Inter_800ExtraBold,
  });

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <ErrorBoundary>
        <SafeAreaProvider>
          <ThemeProvider>
            <AuthProvider>
              <NavigationRoot />
            </AuthProvider>
          </ThemeProvider>
        </SafeAreaProvider>
      </ErrorBoundary>
    </GestureHandlerRootView>
  );
}
